<template>
  <a
    :href="url"
    :target="target"
    :rel="rel"
    @click="linkClick"
    @mouseover="e => this.$emit('mouseover', e)"
    :title="title"
  >
    <slot></slot>
  </a>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('common');
import { query2Search, search2Query } from '@/utils';
import sdk from '@/lib/sdk';

export default {
  props: {
    to: String,
    href: String, // 兼容a标签写法
    target: String,
    rel: String,
    title: {
      type: String,
      require: false,
      default: ''
    },
    inner: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      require: false,
      default: 'insideContainer'
    }
  },
  data() {
    return {
      base: '/'
    };
  },
  computed: {
    ...mapState(['userInfo']),
    isOutsideUrl({ to, href }) {
      const url = to || href || '';
      return url.indexOf('http') === 0 || url.indexOf('https') === 0;
    },

    needBase({ to, href, base }) {
      const url = to || href || '';
      return url.indexOf('//') === -1 && url.indexOf(base) !== 0;
    },

    url({ to, href, needBase, base, $route, isOutsideUrl }) {
      const { query = {} } = $route;
      let url = to || href || '';
      url = needBase ? `${base}${url}` : url;
      // 假如query中带有isDark或chan，且链接非外部链接，保持参数
      if ((query.isDark || query.chan) && !isOutsideUrl) {
        const arr = url.split('#');
        const queryArr = arr[0].split('?');
        const urlQuery = search2Query(queryArr[1]);
        arr[0] = `${queryArr[0]}${query2Search({
          ...urlQuery,
          isDark: query.isDark,
          chan: query.chan
        })}`;

        url = arr.join('#');
      }

      return url;
    }
  },
  methods: {
    linkClick(e) {
      this.$emit('click', e);
      if (sdk.isWPSClient) {
        e.preventDefault();
        this.openBrowser();
      }
    },
    openBrowser() {
      const { type } = this;
      switch (type) {
        case 'insideBrowser': // 内部浏览器
          this.openInsideBrowser();
          break;
        case 'externalBrowser': // 外部浏览器打开
          this.openExternalBrowser();
          break;
        case 'insideContainer': // 内部容器打开
          this.openInsideContainer();
          break;
      }
    },
    openInsideBrowser() {
      sdk
        .navigateOnNewWindow({
          url: this.url,
          isInner: true
        })
        .catch(err => console.log(err));
    },
    openExternalBrowser() {
      sdk
        .navigateOnNewWindow({
          url: this.url,
          isInner: false
        })
        .catch(err => console.log(err));
    },
    openInsideContainer() {
      // 端内容器打开
      sdk.navigateOnSingleWidget({
        url: this.url
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/hc-link/index.vue